<template>
<div>
  <MainHeader
    @loggedOut="LOGOUT"
    :user="user"
  />
  <main class="main-content">
    <Notification :notification="notification" @dismissAlert="REMOVE_NOTIFICATION" />
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view
        :user="user"
        :wishlist="wishlist"
        :favorites="favorites"
        :herd="herd"
        :authenticated="authenticated"
      ></router-view>
    </transition>
  </main>
  <MainFooter :user="user" />
  <div v-if="showBlackout" class="blackout"></div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import store from "./store";

import Notification from './components/Notification/Notification';
import MainHeader from './components/MainHeader/MainHeader';
import MainFooter from './components/MainFooter/MainFooter';

export default {
  name: 'App',
  store,
  data() {
    return {
      showBlackout: false,
      errors: []
    };
  },
  created() {
    this.GET_CURRENT_USER();
  },
  components: {
    MainHeader,
    MainFooter,
    Notification
  },
  computed: {
    ...mapState({
      user: state => state.currentUser.currentUser,
      authenticated: state => state.currentUser.authenticated,
      herd: state => state.currentUser.herd,
      wishlist: state => state.currentUser.wishlist,
      favorites: state => state.currentUser.favorites,
      notification: state => state.notification.notification,
    })
  },
  methods: {
    ...mapActions('currentUser', ['GET_CURRENT_USER', 'LOGOUT']),
    ...mapActions('notification', ['REMOVE_NOTIFICATION']),
  },
  watch: {
    $route() {
      this.REMOVE_NOTIFICATION();
      window.scrollTo(0, 0);
    },
  }
};
</script>

<style lang="scss">
@import './assets/sass/app';
</style>



